import { call, takeEvery, put } from "typed-redux-saga/macro";
import {
  LOAD_KPI_CONFIG,
  FETCH_KPI_CONFIG,
  SET_KPI_METRIC_GOAL,
  SET_KPI_METRIC_GOAL_ACTION,
  LoadKpiConfigAction,
  SetKpiMetricGoalAction,
  LOAD_KPI_CONFIG_SERVICE_URL,
} from "./KpiConfigTypes";
import { acquireEndpoint } from "utils/SmartMerchandiserAPI";
import { callApi } from "utils/SagaUtils";
import { getData, putData } from "services/ApiService";
import { addGlobalAlertState } from "store/global-alert/GlobalAlertActions";

function* fetchKpiConfig(action: LoadKpiConfigAction) {
  const { storeId, language } = action.payload;
  const actionType = FETCH_KPI_CONFIG;
  const constName = Object.keys({ FETCH_KPI_CONFIG })[0].toString();
  const serviceType = LOAD_KPI_CONFIG_SERVICE_URL;
  const endpoint = acquireEndpoint(constName, serviceType, storeId);

  const headersObj = {
    "Accept-Language": language || "en-US",
  };

  const optionsObj = {
    showGenericError: false,
  };

  try {
    yield* call(
      callApi,
      actionType,
      getData,
      null,
      endpoint,
      headersObj,
      optionsObj,
    );
  } catch (e: any) {
    console.error("Error fetching KPI config:", e);
    yield* put({
      type: FETCH_KPI_CONFIG.FAILURE,
      payload: { error: e.message || "Failed to fetch KPI config" },
    });
  }
}

function* setMetricGoal(action: SetKpiMetricGoalAction) {
  yield* put({
    type: SET_KPI_METRIC_GOAL.REQUEST,
  });
  const { storeId, kpiMetricId, kpiMetricGoal, categoryId } = action.payload;
  const actionType = SET_KPI_METRIC_GOAL;
  const constName = Object.keys({ SET_KPI_METRIC_GOAL })[0].toString();
  const serviceType = LOAD_KPI_CONFIG_SERVICE_URL;
  const endpoint = acquireEndpoint(
    constName,
    serviceType,
    storeId,
    kpiMetricId,
  );

  const payload = {
    kpiMetricGoal,
  };

  const optionsObj = {
    showGenericError: false,
    meta: { kpiMetricId, categoryId, kpiMetricGoal },
  };

  try {
    const response = yield* call(
      callApi,
      actionType,
      putData,
      payload,
      endpoint,
      undefined,
      optionsObj,
    );

    if (response && response.type === SET_KPI_METRIC_GOAL.SUCCESS) {
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "kpiConfig.setMetricGoalSuccess",
                defaultMessage: "Metric goal saved successfully",
              },
              severity: "success",
              variant: "standard",
            },
          ],
        }),
      );
    }
  } catch (e: any) {
    console.error("Error setting metric goal:", e);
    yield* put({
      type: SET_KPI_METRIC_GOAL.FAILURE,
      payload: { error: e.message || "Failed to set metric goal" },
    });
    yield* put(
      addGlobalAlertState({
        alertsProps: [
          {
            descriptor: {
              id: "kpiConfig.setMetricGoalFailure",
              defaultMessage: "Failed to save metric goal",
            },
            severity: "error",
            variant: "standard",
          },
        ],
      }),
    );
  }
}

export function* watchLoadKpiConfig() {
  yield* takeEvery(LOAD_KPI_CONFIG, fetchKpiConfig);
}

export function* watchSetMetricGoal() {
  yield* takeEvery(SET_KPI_METRIC_GOAL_ACTION, setMetricGoal);
}
